import { IFindTourState } from './reducer';

export const whitelist: (keyof IFindTourState)[] = ['tours'];

export const migrations: any = {};
